module.exports = __webpack_public_path__ + "static/img/header-en.3375c0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-en.jpg
// module id = 509
// module chunks = 1 2 3 4 5 6